import priceFormat from "../utils/priceFormat";
import colorDict from "../dict/colors";

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    additional_name: {
      type: String,
      required: true
    },
    family: {
      type: String,
      default: ""
    },
    labels: {
      type: Array,
      default: () => []
    },
    bio: {
      type: Boolean,
      default: false
    },
    gcc: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ""
    },
    capacity: {
      type: String,
      default: ""
    },
    "price": {
      type: Number,
      required: true
    },
    "price_per_quantity": {
      type: Array,
      default: () => []
    },
    offer: {
      validator: value => value === null || typeof value === "object",
      default: null
    },
    picture: {
      type: Object,
      default: () => ({})
    },
    descriptions: {
      type: Array,
      default: () => []
    },
    year: {
      validator: value => value === null || typeof value === "number",
      required: true
    },
    "hidden_price": {
      type: Boolean,
      default: false
    },
    "logistic_sender": {
      type: String,
      default: ""
    },
    universe: {
      validator: value => value === null || typeof value === "object",
      default: null
    },
    sold_individually: {
      type: Boolean,
      default: false
    },
    canAddToCart: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isObsolete() {
      return this.offer && this.offer.expiration_date !== null && new Date(this.offer.expiration_date).getTime() < Date.now();
    },
    bestPrice() {
      return this.hasSpecialPrice ? this.offer.price : this.price;
    },
    formatedPricePerQuantity() {
      return this.price_per_quantity.map(({ price, quantity }) => ({
        price: priceFormat(price),
        quantity
      })).sort((a, b) => a.quantity - b.quantity);
    },
    hasFreeProducts() {
      return this.offer && this.offer.products_number_free > 0 && this.offer.products_number > 0;
    },
    hasSpecialPrice() {
      return this.offer && this.offer.price > 0;
    },
    placeholderURL() {
      return require(`../assets/images/wine-placeholder-${this.color ? this.color : "blank"}.png`); // eslint-disable-line import/no-dynamic-require
    },
    largePictureURL() {
      return this.picture.large ? this.picture.large : this.placeholderURL;
    },
    thumbURL() {
      return this.picture.thumb ? this.picture.thumb : this.placeholderURL;
    },
    localeColor() {
      return colorDict[this.color];
    },
    displayColor() {
      return this.color && this.family !== "Champagne";
    },
    displayLogistic() {
      if (this.universe) {
        return this.universe.display_logistic_sender;
      }

      if (this.offer) {
        return this.offer.display_logistic_sender;
      }

      return true;
    },
    orderStep() {
      return this.sold_individually ? 1 : 6;
    },
    capacityLabel() {
      const capacities = {
        "37.5cl": "Demi 37.5cl",
        "50cl": "Pot 50cl",
        "1.5l": "Magnum 1.5l",
        "3l": "Jéroboam 3l",
        "4.5l": "Rhéoboam 4.5l",
        "6l": "Mathusalem 6l",
        "9l": "salmanazar",
        "12l": "balthazar"
      };

      return capacities[this.capacity] ?? this.capacity;
    }
  }
};
